"use strict";
module.exports = {
	curlies: /\{\s*([\w.]+)\s*\}/g,
	colon: /\:([\w.]+)/g
};
